import { useGetTopProvidersQuery } from 'src/api/redux';
import { getSearchQueryParamsForAPI } from 'src/utils/url.helpers';
import { useNewProfile } from 'src/context/providers/ProfileProvider';

const useGetTopProviders = ({
  providerId,
}: {
  providerId: string | number;
}) => {
  const { savedSearchQueryParams } = useNewProfile();

  const queryParams = getSearchQueryParamsForAPI({
    cpt: savedSearchQueryParams.cpt?.map((item) => item.value),
    hcpcs: savedSearchQueryParams.hcpcs?.map((item) => item.value),
    icd: savedSearchQueryParams.icd?.map((item) => item.value),
    drg: savedSearchQueryParams.drg?.map((item) => item.value),
    icdp: savedSearchQueryParams.icdp?.map((item) => item.value),
  });

  const { data, error, isLoading, isFetching, refetch } =
    useGetTopProvidersQuery(
      { providerId: String(providerId), queryParams },
      {
        skip: !providerId,
      }
    );

  return {
    data,
    error,
    isLoading,
    isValidating: isFetching,
    mutate: refetch,
  };
};

export default useGetTopProviders;
